<div class="settings-container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-title">
      <pdq-heading element="h5">Token for Shopify</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card-content">
      <pdq-link
        label="View detailed installation instructions"
        [external]="true"
        [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
      <pdq-input
        [disabled]="true"
        [formControl]="usageTokenControl"
        label="Copy & paste this into Shopify's Components by 'Custom upsell token'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="usageTokenControl"></pdq-extension-preview-token>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-title">
      <pdq-heading element="h5">Settings</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card-content">
      <pdq-input [formControl]="formGroup.get('internalName')" label="Internal name"></pdq-input>
      <pdq-radio-group formControlName="placementMode" label="Component placement" labelSize="small">
        @for (placementMode of placementModeConfig; track placementMode) {
          <pdq-radio-button
            [value]="placementMode.value"
            [checked]="placementMode.checked(formGroup.value['placementMode']) || placementMode.defaultChecked"
            [text]="placementMode.text">
          </pdq-radio-button>
        }
      </pdq-radio-group>

      @if (formGroup?.value['placementMode'] === 'linked') {
        <div class="text-with-link">
          Go to your
          <pdq-link
            label="online store editor"
            [external]="true"
            [url]="shop$ | async | shopCheckoutEditorUrl"
            size="small"></pdq-link>
          to define which shipping method this extension shows up for
        </div>
      }
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-title">
      <pdq-heading element="h5" text="Configure"></pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card-content">
      <pdq-input [formControl]="formGroup.get('title')" label="Display title"></pdq-input>
      <div class="field-group">
        <pdq-dropdown
          title="Style"
          [style.width]="'100%'"
          (onChange)="onStyleTypeChange($event)"
          [defaultOption]="formGroup.value.general.styleType | titlecase | primitiveDropdownOptionPipe"
          [options]="styleOptions"></pdq-dropdown>
        <pdq-input-arrows
          [style.width]="'100%'"
          [widthSize]="'fullwidth'"
          [min]="MIN_BLOCKS"
          [max]="MAX_BLOCKS"
          [formControl]="formGroup.get('numOfBlocks')"
          [label]="'Number of ' + formGroup.get('general.styleType')?.value + ' (maximum 4)'"></pdq-input-arrows>
      </div>
      <div class="field-group" [formGroupName]="'general'">
        <pdq-dropdown
          title="Border"
          [style.width]="'100%'"
          [options]="borderTypeOptions"
          formControlName="border"
          [defaultOption]="formGroup.get('border')?.value | titlecase | primitiveDropdownOptionPipe"></pdq-dropdown>
        <pdq-dropdown
          title="Border width"
          [style.width]="'100%'"
          [options]="borderWidthOptions"
          formControlName="borderWidth"
          [defaultOption]="
            formGroup.get('borderWidth')?.value | titlecase | primitiveDropdownOptionPipe
          "></pdq-dropdown>
        <pdq-dropdown
          title="Corner radius"
          [style.width]="'100%'"
          [options]="cornerRadiusOptions"
          formControlName="cornerRadius"
          [defaultOption]="
            formGroup.get('cornerRadius')?.value | titlecase | primitiveDropdownOptionPipe
          "></pdq-dropdown>
        <pdq-dropdown
          title="Padding"
          [style.width]="'100%'"
          [options]="paddingOptions"
          formControlName="padding"
          [defaultOption]="formGroup.get('padding')?.value | titlecase | primitiveDropdownOptionPipe"></pdq-dropdown>
      </div>
    </div>
  </pdq-card>

  <ng-container [formArrayName]="'blocks'">
    @for (block of formGroup.get('blocks')['controls']; track block; let i = $index) {
      <pdq-card variant="popover" color="white" [formGroupName]="i">
        <div class="card-title">
          <pdq-heading
            element="h5"
            [text]="(formGroup.value.general.styleType | titlecase | singularizePipe) + ' ' + (i + 1)"></pdq-heading>
        </div>
        <pdq-divider></pdq-divider>
        <div class="card-content">
          <div class="section">
            <div class="field-group">
              <pdq-dropdown
                [style.width]="'100%'"
                formControlName="type"
                (onChange)="onBlockTypeChange($event, i)"
                [defaultOption]="block.value.type | titlecase | primitiveDropdownOptionPipe"
                [options]="blockTypeOptions"
                title="Block type"></pdq-dropdown>
            </div>
            @if (block.controls.title) {
              <pdq-input [formControl]="block.controls.title" label="Title"></pdq-input>
            }
            @if (block.controls.bodyText) {
              <rich-text-editor
                [label]="'Body'"
                [control]="block.controls.bodyText"
                [enableLinkInsert]="true"
                [invalidMsg]="block.controls.bodyText?.getError('body_text_missmatch')"
                [config]="{
                  items: dynamicFieldsAutocompleteOptions$ | async,
                  triggerChar: '{',
                  filterByKey: 'searchTerm',
                  removeTriggerCharOnSelect: true,
                  descriptionKey: 'description',
                  variant: 'categorizedOptions',
                }">
              </rich-text-editor>
              <p style="font-size: 13px">
                {{ 'Dynamic fields available. Type { to see options.' }}<br />
                {{ 'Ex: type {product.name} to display the product name of an item in the cart.' }}
              </p>
            }
            @if (block.controls.image) {
              <div class="block-controls-image">
                <pdq-input-file
                  (onPreviewChange)="onPreviewChange($event, i)"
                  (onClearFile)="onClearImage(i)"
                  fileType="img"
                  size="small"
                  label="Icon"
                  class="dynamic-content-image-input"
                  tooltip=".png, maximum size 500KB"
                  variant="optionlist"
                  maxKBSize="500"
                  [allowClear]="block.value.type !== BlockType.IMAGE"
                  [value]="block.value | blockImageSrc"
                  [initialImage]="defaultIconUrl"></pdq-input-file>
                <div class="image-controls">
                  <p class="image-controls__header-text">Image Width, Height (Auto-maintains image proportions)</p>
                  <div class="field-group">
                    @if (block.controls.imageContainerWidth) {
                      <pdq-input-arrows
                        [min]="0"
                        [required]="false"
                        placeholder="None"
                        formControlName="imageContainerWidth"></pdq-input-arrows>
                    }
                    @if (block.controls.imageContainerHeight) {
                      <pdq-input-arrows
                        [min]="0"
                        placeholder="None"
                        [required]="false"
                        formControlName="imageContainerHeight"></pdq-input-arrows>
                    }
                  </div>
                </div>
              </div>

              @if (block.value.type === BlockType.IMAGE) {
                <pdq-popover-container [loading]="false">
                  <div class="action-list" #popoverContent></div
                ></pdq-popover-container>
                <div class="section">
                  <pdq-checkbox
                    formControlName="enableClickableRow"
                    label="Enable Clickable Row"
                    secondaryLabel="Check this box if you'd like users to click the row and open a URL." />

                  @if (block.value.enableClickableRow) {
                    <div class="field-group">
                      <pdq-input
                        formControlName="clickableRowUrl"
                        placeholder="Enter URL"
                        class="clickable-row-image-url-input" />
                      <pdq-button
                        [disabled]="!block.value.clickableRowUrl?.trim()"
                        (onClick)="onCheckUrl(block.value.clickableRowUrl)"
                        >Check URL</pdq-button
                      >
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      </pdq-card>
    }
  </ng-container>
</div>
